import { useMutation } from '@tanstack/react-query';
import { requestCCApi } from 'src/utils';

export const useDeleteChangeSet = () => {
  return useMutation({
    mutationFn: async (changeSetId: string | number) => {
      const response = await requestCCApi({
        url: `/changeSets/${changeSetId}`,
        method: 'DELETE',
      });

      return response;
    },
  });
};
